<template>
    <v-row v-if="classifiersLoaded && instanceData">
        <v-col>
            <EditForm
                :account-id="accountId"
                :related-type="relatedType"
                :related-id="supplierId"
                :instance-data="instanceData"
                @close="closeEdit"
            >
                <template v-slot:header>
                    <div class="headline" v-html="pageTitle" /> <!-- INPUT FROM STATIC TRANSLATION -->
                </template>
                <template v-slot:buttons-left="{}">
                    <v-btn
                        v-if="supplierId"
                        color="error"
                        text
                        @click="deleteClick"
                    >
                        {{ $t("Delete") }}
                    </v-btn>
                </template>
            </EditForm>
        </v-col>
    </v-row>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { Router } from "@/composables/Router";
import { $t } from "@/i18n";
import AppModule from "../../store/modules/app";
import SupplierModule from "../../store/modules/supplier";
import EditForm from "../../components/CustomForm/EditForm";
import DialogModule from "../../store/modules/dialog";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "SupplierEditView",
    components: {
        EditForm
    },
    setup(props, ctx) {
        const { fetchClassifiers, supplier_types } = AppModule();
        const { fetchSupplier, deleteSupplier } = SupplierModule();
        const { openConfirmDialog, setConfirmOptions } = DialogModule();
        const router = Router();

        const classifiersLoaded = ref(false);
        const instanceData = ref(null);

        const supplierId = computed(() => {
            if (router.currentRoute.name === "supplier_new")
                return 0;
            else
                return parseInt(router.currentRoute.params.id);
        });
        const accountId = ref(null);
        const supplierTypeId = ref(null);
        const supplierType = ref(null);

        const relatedType = computed(() => {
            if (supplierTypeId.value == null) return null;
            return "supplier.{0}".format(supplierTypeId.value);
        });
        const pageTitle = computed(function () {
            if (!classifiersLoaded.value) return "";
            if (!accountId.value) return "";
            let supplierType = supplier_types.value[accountId.value].find(x => x.id === supplierTypeId.value);
            return "{0}<span class='mx-2'>›</span>{1}".format(
                router.currentRoute.name === "supplier_edit" ? $t("Edit supplier") : $t("New supplier"),
                supplierType == null ? "" : supplierType.title
            );
        });

        const loadClassifiers = () => {
            let data = {
                types: ["supplier_types", "custom_fields", "roles"],
                account_id: accountId.value
            };
            fetchClassifiers(data)
                .then(() => {
                    classifiersLoaded.value = true;
                    supplierType.value = supplier_types.value[accountId.value].find(x => x.id === supplierTypeId.value);
                })
                .catch(ex => errorDialog.showError(ex));
        };
        const loadData = () => {
            if (supplierId.value > 0) {
                fetchSupplier(supplierId.value)
                    .then(resp => {
                        accountId.value = resp.account_id;
                        supplierTypeId.value = resp.type_id;
                        loadClassifiers();

                        instanceData.value = resp;
                    })
                    .catch(ex => errorDialog.showError(ex));
            }
            else {
                accountId.value = parseInt(router.currentRoute.params.account_id);
                supplierTypeId.value = parseInt(router.currentRoute.params.type_id);
                loadClassifiers();

                instanceData.value = {
                    id: 0, account_id: accountId.value, type_id: supplierTypeId.value, name: ""
                };
            }
        };
        const closeEdit = () => {
            ctx.root._router.push("/suppliers?account_id={0}&type_id={1}".format(accountId.value, supplierTypeId.value));
        };
        const deleteClick = () => {
            setConfirmOptions({
                title: $t("Are you sure you wish to delete this supplier?"),
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: deleteConfirmed
            });
            openConfirmDialog();
        };
        const deleteConfirmed = () => {
            deleteSupplier(supplierId.value)
                .then(resp => closeEdit())
                .catch(ex => errorDialog.showError(ex));
        };

        loadData();

        return {
            classifiersLoaded,
            pageTitle,
            accountId,
            relatedType,
            supplierId,
            instanceData,
            deleteClick,
            closeEdit
        };
    }
};
</script>
